const FormattedDate = ({ date }) => {
    if (!date) return null;

    return new Intl.DateTimeFormat('fr-FR', {
        day: '2-digit',
        month: 'long',
        year: 'numeric',
    }).format(new Date(date));
};

export default FormattedDate;